/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import { j as i } from "../../chunks/jsx-runtime.BwWtxLpl.js";
import c from "react";
import { omit as y } from "radash";
import m from "../../utils/warning.js";
import "../../chunks/currency-utils.DnRSwher.js";
import "../../contexts/formeck-config/formeck-config.js";
import "../../contexts/stepper/stepper.js";
import "@nubeteck/components";
import g from "../inputs/alert/alert.js";
import x from "../inputs/radio/radio.js";
import k from "../inputs/input/input.js";
import h from "../inputs/switch/switch.js";
import w from "../inputs/select/select.js";
import s from "../inputs/textarea/textarea.js";
import f from "../inputs/checkbox/checkbox.js";
import I from "../inputs/segmented/segmented.js";
import o from "../inputs/date-picker/date-picker.js";
import d from "../inputs/time-picker/time-picker.js";
import P from "../inputs/color-picker/color-picker.js";
import j from "../inputs/input-number/input-number.js";
import R from "../inputs/input-search/input-search.js";
import M from "../inputs/input-password/input-password.js";
const V = ({ name: e, label: r, ...t }) => {
  c.useEffect(() => {
    m("FormInput is obsolete, use the fields (inputs) directly."), m(
      "FormInput won't continue to be updated and any errors won't be fixed."
    );
  }, []);
  const n = c.useMemo(() => ({
    radio: /* @__PURE__ */ i.jsx(
      x,
      {
        name: e,
        label: r,
        ...t.type === "radio" ? y(t, ["type"]) : {}
      }
    ),
    date: /* @__PURE__ */ i.jsx(
      o,
      {
        name: e,
        label: r,
        ...t.type === "date" ? y(t, ["type"]) : {}
      }
    ),
    switch: /* @__PURE__ */ i.jsx(
      h,
      {
        name: e,
        label: r,
        ...t.type === "switch" ? y(t, ["type"]) : {}
      }
    ),
    select: /* @__PURE__ */ i.jsx(
      w,
      {
        name: e,
        label: r,
        ...t.type === "select" ? y(t, ["type"]) : {}
      }
    ),
    time: /* @__PURE__ */ i.jsx(
      d,
      {
        name: e,
        label: r,
        ...t.type === "time" ? y(t, ["type"]) : {}
      }
    ),
    color: /* @__PURE__ */ i.jsx(
      P,
      {
        name: e,
        label: r,
        ...t.type === "color" ? y(t, ["type"]) : {}
      }
    ),
    search: /* @__PURE__ */ i.jsx(
      R,
      {
        name: e,
        label: r,
        ...t.type === "search" ? y(t, ["type"]) : {}
      }
    ),
    number: /* @__PURE__ */ i.jsx(
      j,
      {
        name: e,
        label: r,
        ...t.type === "number" ? y(t, ["type"]) : {}
      }
    ),
    textarea: /* @__PURE__ */ i.jsx(
      s,
      {
        name: e,
        label: r,
        ...t.type === "textarea" ? y(t, ["type"]) : {}
      }
    ),
    checkbox: /* @__PURE__ */ i.jsx(
      f,
      {
        name: e,
        label: r,
        ...t.type === "checkbox" ? y(t, ["type"]) : {}
      }
    ),
    password: /* @__PURE__ */ i.jsx(
      M,
      {
        name: e,
        label: r,
        ...t.type === "password" ? y(t, ["type"]) : {}
      }
    ),
    week: /* @__PURE__ */ i.jsx(
      o.WeekPicker,
      {
        name: e,
        label: r,
        ...t.type === "week" ? y(t, ["type"]) : {}
      }
    ),
    month: /* @__PURE__ */ i.jsx(
      o.MonthPicker,
      {
        name: e,
        label: r,
        ...t.type === "month" ? y(t, ["type"]) : {}
      }
    )
  }), [r, e, t]), u = c.useMemo(() => ({
    alert: /* @__PURE__ */ i.jsx(
      g,
      {
        name: e,
        label: r,
        ...t.type === "alert" ? y(t, ["type"]) : {}
      }
    ),
    year: /* @__PURE__ */ i.jsx(
      o.YearPicker,
      {
        name: e,
        label: r,
        ...t.type === "year" ? y(t, ["type"]) : {}
      }
    ),
    "radio-group": /* @__PURE__ */ i.jsx(
      x.Group,
      {
        name: e,
        label: r,
        ...t.type === "radio-group" ? y(t, ["type"]) : {}
      }
    ),
    "checkbox-group": /* @__PURE__ */ i.jsx(
      f.Group,
      {
        name: e,
        label: r,
        ...t.type === "checkbox-group" ? y(t, ["type"]) : {}
      }
    ),
    "time-range": /* @__PURE__ */ i.jsx(
      d.RangePicker,
      {
        name: e,
        label: r,
        ...t.type === "time-range" ? y(t, ["type"]) : {}
      }
    ),
    "range-picker": /* @__PURE__ */ i.jsx(
      o.RangePicker,
      {
        name: e,
        label: r,
        ...t.type === "range-picker" ? y(t, ["type"]) : {}
      }
    ),
    currency: /* @__PURE__ */ i.jsx(
      j,
      {
        name: e,
        label: r,
        formatMode: "currency",
        ...t.type === "currency" ? y(t, ["type"]) : {}
      }
    ),
    segmented: /* @__PURE__ */ i.jsx(
      I,
      {
        name: e,
        label: r,
        options: t.type === "segmented" ? t.options : {},
        ...t.type === "segmented" ? y(t, ["type", "options"]) : {}
      }
    )
  }), [r, e, t]);
  return c.useCallback(() => n[t.type] ? n[t.type] : u[t.type] ? u[t.type] : (t.type === "reset" && m("There is a button component for the form reset action."), t.type === "range" && m("Range input coming soon"), /* @__PURE__ */ i.jsx(
    k,
    {
      name: e,
      ...t,
      label: r
    }
  )), [n, r, u, e, t])();
};
export {
  V as default
};
